<template>
  <div class="xcbf">
    <div class="info-body">
      <div class="title">相册备份</div>
      <div class="desc">一键备份，轻松释放你的手机空间</div>
      <div class="slogan-wrap">
        <div class="slogan-item">
          <div class="slogan-icon slogan-icon-01"></div>
          <div class="slogan-text">更快捷</div>
        </div>
        <div class="slogan-item">
          <div class="slogan-icon slogan-icon-02"></div>
          <div class="slogan-text">不压缩</div>
        </div>
        <div class="slogan-item">
          <div class="slogan-icon slogan-icon-03"></div>
          <div class="slogan-text">跨网传</div>
        </div>
      </div>
      <div class="download-wrap">
        <div class="download-left">
          <div class="download-image"></div>
          <div class="download-text">下载APP使用</div>
        </div>
        <div class="download-right">
          <div class="right-title">前往应用商店搜索<b>【节点小宝】</b></div>
          <div class="download-search">
            <div class="search-icon"></div>
            <div class="search-text">节点小宝</div>
          </div>
          <div class="download-apps"></div>
        </div>
      </div>
    </div>
    <div class="swiper-body">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide swiper-slide-02">
            <img :src="require('../../assets/home/xcbf/nav-02.jpg')" />
          </div>
          <div class="swiper-slide swiper-slide-01">
            <img :src="require('../../assets/home/xcbf/nav-01.jpg')" />
          </div>
          <div class="swiper-slide swiper-slide-03">
            <img :src="require('../../assets/home/xcbf/nav-03.jpg')" />
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/dist/idangerous.swiper.min.js";
import "swiper/dist/idangerous.swiper.css";
export default {
  data: function () {
    return {
      swiperObj: null,
    };
  },
  methods: {
    myswiper: function () {
      if (!this.swiperObj) {
        this.swiperObj = new Swiper(".swiper-container", {
          mode: "horizontal", // Slides的滑动方向(水平)
          initialSlide: 1, // 设定初始化时slide的索引
          slidesPerView: "auto", // 同时显示的幻灯片数量
          // updateOnImagesReady: true, // 所有内部图像（<img>标签）装入后重新初始化Swiper
          // resizeReInit: true, // windows改变尺寸时swiper会重新初始化
          loop: true, // 循环模式
          autoplay: 3000,
          spaceBetween: 0,
          pagination: ".swiper-pagination",
          paginationClickable: true,
          centeredSlides: true,
        });
      } else {
        console.log("reInit");
        this.swiperObj.reInit();
        this.swiperObj.startAutoplay();
      }
    },
  },
  activated: function () {
    this.myswiper();
  },
  deactivated: function () {
    this.swiperObj && this.swiperObj.stopAutoplay();
  },
};
</script>

<style lang="less">
.swiper-pagination {
  width: 100%;
  height: 20px;
  text-align: center;
  padding-left: 10px;
}
.swiper-pagination-switch {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: rgba(59, 70, 198, 0.3);
  cursor: pointer;
  margin: 0 2px;
}
.swiper-visible-switch {
  background: rgba(59, 70, 198, 0.3);
}
.swiper-active-switch {
  background-color: #3b46c6;
  width: 12px;
}
</style>

<style lang="less" scoped>
.swiper-body {
  position: absolute;
  top: 45px;
  right: 50px;
  width: 420px;
}

.swiper-container {
  width: 350px;
  height: 350px;
  text-align: center;
  padding-bottom: 0px;
  padding-left: 25px;
  font-size: 0;

  .swiper-wrapper {
    width: 1000px;
    font-size: 0;
    // padding-left: 50px;
  }

  .swiper-slide {
    width: 140px;
    transition: all 0.3s;
    transform: scale(0.8);
    border-radius: 16px;
    overflow: hidden;
    font-size: 0;
    box-shadow: 4px 4px 16px 0px rgba(105, 100, 115, 0.28);
    position: relative;
  }

  .swiper-slide-visible {
    transform: scale(0.8);
    transform-origin: center bottom;
    z-index: 1;
    margin: 0 20px;
    opacity: 0.7;
  }

  .swiper-slide-active {
    transform: scale(1);
    border: 4px solid #ffffff;
    z-index: 2;
    margin: 0 -50px;
    height: 320px;
    width: 150px;
    opacity: 1;
  }

  img {
    width: 100%;
  }
}

.xcbf {
  padding-top: 1px;
  position: relative;

  .info-body {
    margin-left: 80px;
    margin-top: 55px;
  }
  .title {
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.25);
    font-family: PingFang SC;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    color: #3535c1;
    background: var(
      --unnamed,
      linear-gradient(188deg, #655de1 0%, #3535c1 100%)
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .desc {
    color: var(--h-24-a-4-a-4-a, #4a4a4a);
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 6px;
  }
  .slogan-wrap {
    width: 330px;
    height: 41px;
    flex-shrink: 0;
    border-radius: 24px;
    background-color: rgba(185, 200, 255, 0.3);
    background-image: linear-gradient(
      181deg,
      rgba(190, 167, 255, 0.3) 0%,
      rgba(215, 175, 255, 0.3) 36.98%,
      rgba(185, 200, 255, 0.3) 100%
    );
    backdrop-filter: blur(2px);
    text-align: center;
    margin-top: 28px;
    .slogan-item {
      display: inline-block;
      vertical-align: top;
      margin-top: 6px;
      text-align: left;
      .slogan-icon {
        width: 28px;
        height: 28px;
        flex-shrink: 0;
        display: inline-block;
        vertical-align: top;
        background-size: 100% 100%;
      }
      .slogan-icon-01 {
        background-image: url(../../assets/home/xcbf/slogan-01.png);
      }
      .slogan-icon-02 {
        background-image: url(../../assets/home/xcbf/slogan-02.png);
      }
      .slogan-icon-03 {
        background-image: url(../../assets/home/xcbf/slogan-03.png);
      }
      .slogan-text {
        display: inline-block;
        vertical-align: top;
        height: 28px;
        line-height: 28px;
        margin-right: 24px;
        margin-left: 4px;
        font-size: 14px;
        color: #3535c1;
        background: var(
          --unnamed,
          linear-gradient(188deg, #655de1 0%, #3535c1 100%)
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .slogan-item:last-child {
      .slogan-text {
        margin-right: 0;
      }
    }
  }

  .download-wrap {
    margin-top: 85px;
    .download-left {
      display: inline-block;
      vertical-align: top;
      width: 92px;
      height: 113px;
      flex-shrink: 0;
      border-radius: 4px;
      background: linear-gradient(
        180deg,
        rgba(190, 167, 255, 0.2) 0%,
        rgba(215, 175, 255, 0.2) 36.98%,
        rgba(185, 200, 255, 0.2) 100%
      );
      .download-image {
        width: 76px;
        height: 76px;
        flex-shrink: 0;
        background-image: url(../../assets/home/xcbf/qrcode.png);
        margin: 0 auto;
        background-size: 94% 94%;
        background-repeat: no-repeat;
        background-position: center center;
        background-color: #ffffff;
        margin-top: 8px;
      }
      .download-text {
        color: var(--h-24-a-4-a-4-a, #4a4a4a);
        font-family: PingFang SC;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-align: center;
        margin-top: 4px;
      }
    }
    .download-right {
      display: inline-block;
      vertical-align: top;
      margin-left: 12px;
      .download-search {
        width: 164px;
        height: 28px;
        flex-shrink: 0;
        border: 4px solid rgba(185, 200, 255, 0.3);
        border-radius: 6px;
        margin-top: 12px;
        .search-icon {
          display: inline-block;
          vertical-align: top;
          width: 16px;
          height: 16px;
          flex-shrink: 0;
          background-image: url(../../assets/home/xcbf/search-icon.png);
          background-size: 100% 100%;
          margin-top: 6px;
          margin-left: 16px;
        }
        .search-text {
          display: inline-block;
          vertical-align: top;
          color: var(--h-11-f-1-f-1-f, #1f1f1f);
          text-align: center;
          font-family: PingFang SC;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 20px;
          margin-top: 4px;
          margin-left: 8px;
        }
      }
      .download-apps {
        width: 184px;
        height: 40px;
        flex-shrink: 0;
        background-image: url(../../assets/home/xcbf/download-icon.png);
        background-size: 100% 100%;
        margin-top: 10px;
        margin-left: -4px;
      }
    }
  }
}
</style>